<div class="p3 p-a-1 p-r-2 p-l-2">
    <ng-content></ng-content>
</div>